import { render, staticRenderFns } from "./PlayButton.vue?vue&type=template&id=1f97edf1&scoped=true"
import script from "./PlayButton.vue?vue&type=script&lang=js"
export * from "./PlayButton.vue?vue&type=script&lang=js"
import style0 from "./PlayButton.vue?vue&type=style&index=0&id=1f97edf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f97edf1",
  null
  
)

export default component.exports